import {
  CollaborativeDocumentFragment,
  CollaborativeDocumentQuery,
  CollaborativeDocumentQueryVariables,
  useCollaborativeDocumentSuspenseQuery,
  withStandardGetSuspenseHook,
} from '@spotify/confidence-graphql';

const useCollaborativeDocumentSuspenseImpl = withStandardGetSuspenseHook<
  CollaborativeDocumentQuery,
  CollaborativeDocumentFragment,
  'collaborativeDocument',
  CollaborativeDocumentQueryVariables
>(useCollaborativeDocumentSuspenseQuery, 'collaborativeDocument', {
  fetchPolicy: 'cache-and-network',
});

type CollaborativeDocumentSuspenseOptions = Parameters<
  typeof useCollaborativeDocumentSuspenseImpl
>[0];

export const useCollaborativeDocumentSuspense = (
  options: CollaborativeDocumentSuspenseOptions,
): ReturnType<typeof useCollaborativeDocumentSuspenseImpl> =>
  useCollaborativeDocumentSuspenseImpl(options);
